import { chakra } from '@chakra-ui/react';

var Label = /*#__PURE__*/chakra('label', {
  baseStyle: {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'top',
    position: 'relative',
    _disabled: {
      cursor: 'not-allowed'
    }
  }
});

export { Label };
//# sourceMappingURL=Label.js.map
